// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"6176828d","806":"6bbb50ef"}[chunkId] + ".chunk.js";
};